<script setup lang="ts">
import { computed } from 'vue';

import { SelectOption } from '@/classes/SelectOption';
import ChoiceChip from '@/components/forms/controls/ChoiceChip.vue';

const modelValue = defineModel<string>('modelValue', {
  default: () => ''
});

const props = defineProps<{
  options: SelectOption[];
  name: string;
  showInputs?: boolean;
}>();

const value = computed({
  get() {
    return modelValue.value;
  },
  set(newValue: string) {
    modelValue.value = newValue;
  }
});

function handleSelect(checked: boolean, optionValue: string) {
  if (checked) {
    value.value = optionValue;
  }
}
</script>

<template>
  <menu class="radioGroup">
    <li v-for="(option, index) in props.options"
        :key="index"
        class="radioGroup-item">
      <ChoiceChip type="radio"
                  :option="option"
                  :checked="value === option.value"
                  :name="name"
                  :show-input="props.showInputs"
                  @change="handleSelect" />
    </li>
  </menu>
</template>

<style lang="scss">
.radioGroup {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spc16-8);

  &-item {
    // styles pour les éléments de liste si nécessaire
  }
}
</style>
